import { BuilderComponentGroup } from '../types'

export const ServiceDesignBlocks: BuilderComponentGroup = {
  id: 'service',
  title: 'Service',
  components: [
    {
      compId: 'service1',
      title: 'Service 1',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'service2',
      title: 'Service 2',
      icon: 'Profile2',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
